import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { Table } from "antd";
import React from "react";
import { DateFormat, DateTimeFormat, YesNoFormat } from "./FormattersTS";
import { isNullOrUndefined } from "../../../swzutils";
const formatValue = (type, value) => {
    if (isNullOrUndefined(value)) {
        return _jsx(_Fragment, { children: "\u2014" });
    }
    switch (type) {
        case "BOOLEAN":
            return _jsx(YesNoFormat, { value: value });
        case "DATE":
            return _jsx(DateFormat, { value: value });
        case "DATE_TIME":
            return _jsx(DateTimeFormat, { value: value });
        case "NUMBER":
        case "STRING":
            return value || _jsx(_Fragment, { children: "\u2014" }); // Sow empty strings as dash
    }
};
const ChangeSetTable = (props) => {
    const hidePreviousValue = props.hidePreviousValue ?? false;
    const columns = [
        {
            title: 'Attribute',
            dataIndex: 'description',
            width: '30%'
        }
    ];
    if (!hidePreviousValue) {
        columns.push({
            title: 'Previous Value',
            dataIndex: 'previousValue',
            width: '35%',
            render: (value, record, index) => {
                return _jsx("div", { style: { whiteSpace: "pre-wrap" }, children: formatValue(record.type, value) });
            }
        });
    }
    columns.push({
        title: 'Updated Value',
        dataIndex: 'updatedValue',
        width: (hidePreviousValue) ? '35%' : '70%',
        render: (value, record, index) => {
            return _jsx("div", { style: { whiteSpace: "pre-wrap" }, children: formatValue(record.type, value) });
        }
    });
    return (_jsx(Table, { size: "small", style: props.style, bordered: true, title: props.title, pagination: false, rowKey: (record) => record.property, columns: columns, dataSource: props.changes }));
};
export default ChangeSetTable;
